import { BaseApi, ApiResponse } from "../utils/request";
import type {
  BoostRecordDto,
  CashbackBoostCheckResp,
  CashbackBoostRequest,
} from "./cashbackBoost.types";

export type {
  BoostRecordDto,
  BoostStatus,
  CashbackBoostCheckResp,
  CashbackBoostPopupItem,
  CashbackBoostRechargeState,
  CashbackBoostRequest,
  CashBackRow,
  CashbackBoostDialogKind,
  PendingPayPayload,
} from "./cashbackBoost.types";

export class CashbackBoostApi extends BaseApi {
  async check(
    body: CashbackBoostRequest
  ): Promise<ApiResponse<CashbackBoostCheckResp, true>> {
    return this.post<CashbackBoostCheckResp, true>(
      "/api/cashback_boost/check",
      body
    );
  }

  async info(
    recordId: string
  ): Promise<ApiResponse<BoostRecordDto, true>> {
    return this.post<BoostRecordDto, true>("/api/cashback_boost/info", {
      recordId,
    });
  }

  async claimBoost(
    recordId: string
  ): Promise<ApiResponse<BoostRecordDto, true>> {
    return this.post<BoostRecordDto, true>("/api/cashback_boost/claim_boost", {
      recordId,
    });
  }

  async markRead(recordId: string): Promise<ApiResponse<null, true>> {
    return this.post<null, true>("/api/cashback_boost/mark_read", {
      recordId,
    });
  }

  async markReadBatch(recordIds: string[]): Promise<ApiResponse<null, true>> {
    return this.post<null, true>("/api/cashback_boost/mark_read", {
      recordIds,
    });
  }
}

export const cashbackBoostApi = new CashbackBoostApi();

export const checkCashbackBoost = (body: CashbackBoostRequest) =>
  cashbackBoostApi.check(body);

export const claimCashbackBoost = (recordId: string) =>
  cashbackBoostApi.claimBoost(recordId);

export const markCashbackBoostRead = (recordId: string) =>
  cashbackBoostApi.markRead(recordId);
